import {
  MFAChallengeDTO,
  MFAChallengePayload,
  MFAChallengeVerifyDTO,
  MFAChallengeVerifyPayload,
} from './mfaTypes'

import { api } from '@/api/api'
import { endpoints } from '@/api/endpoints'

async function startMfa(
  payload: MFAChallengePayload,
): Promise<MFAChallengeDTO> {
  const res = await api.post(endpoints.mfa.startMfa, payload)

  return res.data
}

async function verifyMfa({
  challengeId,
  code,
}: MFAChallengeVerifyPayload): Promise<MFAChallengeVerifyDTO> {
  const res = await api.post(endpoints.mfa.verifyMfa(challengeId), { code })

  return res.data
}

export const mfaApi = {
  startMfa,
  verifyMfa,
}
